// extracted by mini-css-extract-plugin
module.exports = {"vantageBlue":"#3f1f5a","success":"styles_success__2RHye","info":"styles_info__2AWyZ","danger":"styles_danger__396GM"};